<template>
  <div :class="'SharingModal' + (this.$store.state.sharing ? ' SharingModal--visible' : '')">
    <div class="SharingModal__ctn" :style="'background-image: url(' + require('@/assets/icons/full_logo_v_' + lang + '.svg') + ')'">
      <h2 class="Mobile__title">
        <img class="hide-sm" :src="require('@/assets/icons/share_black.svg')" alt=""><span v-html="words[lang].share.ShareThisMap"></span>
      </h2>
      <h3 class="hide-sm">{{ words[lang].share.OnTheSocialMedias }}</h3>
      <div class="SharingModal__socialMediasCtn">
        <IconButton
          :hint="words[lang].share.ShareOnLinkedin"
          icon="linkedin"
          v-on:clicked="shareOnLinkedin"
          :is-triggerable="false"
          id="linkedin"
          className="IconButton__icon--lg"
          />
        <IconButton
          :hint="words[lang].share.ShareOnFacebook"
          icon="facebook"
          v-on:clicked="shareOnFacebook"
          :is-triggerable="false"
          id="facebook"
          className="IconButton__icon--lg"
          />
        <IconButton
          :hint="words[lang].share.ShareOnTwitter"
          icon="twitter"
          v-on:clicked="shareOnTwitter"
          :is-triggerable="false"
          id="twitter"
          className="IconButton__icon--lg"
          />
      </div>
      <h3 class="hide-sm">{{ words[lang].share.EmbedThisMap }}</h3>
      <h3 class="Mobile__title show-sm">{{ words[lang].share.CopyIframe }}</h3>
      <IframeSharing
        :data-active="this.$store.state.iframe"
        :active="this.$store.state.iframe"
        />
    </div>
    <div class="SharingModal__bg" v-on:click="toggleSharing"></div>
  </div>
</template>

<script>
import { words } from '@/constants/lang'
import IframeSharing from './IframeSharing.vue'
import IconButton from './IconButton.vue'

export default {
  name: 'SharingModal',
  components: { IframeSharing, IconButton },
  data: () => ({
    words
  }),
  computed: {
    lang: function () {
      return this.$store.state.language.lang
    },
    currentPage: function () {
      return this.$store.state.fullPath
    },
    shareLink: function () {
      if (this.$store.state.language.lang === 'en')
        return "https://www.ecpm.org/en/the-death-penalty-worldwide/";
      else
        return "https://www.ecpm.org/la-peine-de-mort-dans-le-monde/";
    }
  },
  methods: {
    shareOnFacebook() {
      window.open("https://www.facebook.com/sharer/sharer.php?u=" + this.shareLink)
    },
    shareOnTwitter() {
      window.open("https://twitter.com/share?text=ECPM - Death penalty - World map&url=" + encodeURIComponent(this.shareLink))
    },
    shareOnLinkedin() {
      window.open("https://www.linkedin.com/sharing/share-offsite/?url=" + encodeURIComponent(this.shareLink))
    },
    toggleSharing: function () {
      this.$store.commit('toggleSharing')
    }
  }
}
</script>

<style scoped lang="less">

  @import "../less/_var.less";

  .SharingModal {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9;
    justify-content: center;
    align-items: center;
    transform: translateX(-9999px);
    transition: transform 0.01ms 0.3s linear;

    &--visible {
      transform: translateX(0);
      transition: transform 0.01ms linear;

      .SharingModal__ctn {
        transform: translateY(0);
        opacity: 1;
      }

      .SharingModal__bg {
        opacity: 1;
      }
    }

    &__ctn {
      width: 450px;
      max-width: 100%;
      margin: 15px;
      max-height: 100%;
      background: url('../../src/assets/icons/full_logo_v_fr.svg') no-repeat top -5px right -12px, white;
      background-size: 100px;
      box-shadow: 0 10px 25px -5px rgba(0,0,0,0.15);
      border-radius: 5px;
      padding: 60px 20px;
      position: relative;
      z-index: 1;
      transform: translateY(50px);
      opacity: 0;
      transition: opacity 0.15s ease-in, transform 0.15s ease-in;
      justify-content: center;
      align-items: center;
      display: flex;
      flex-flow: column nowrap;

      .SharingModal__socialMediasCtn {
        display: flex;
        flex-flow: row nowrap;
        width: 100%;
        justify-content: center;

        & > *:not(:last-child) {
          margin-right: 10px;
        }
      }

      h2, h3 {
        font-family: @font-secondary;
        font-weight: 100;
        text-transform: uppercase;
      }

      h2 {
        font-size: 1.3em;
        margin: 0;
        margin-bottom: 10px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        color: #000;

        img {
          width: 24px;
          margin-right: 10px;
        }

        span {
          line-height: 0;
          margin-top: 4px;
        }
      }
      h3 {
        font-size: 0.85em;
        color: #666;
        margin-top: 20px;
      }
    }

    &__bg {
      background: rgba(255,255,255,0.4);
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      cursor: pointer;
      opacity: 0;
      transition: opacity 0.15s ease-in;
    }
  }

  @media screen and (max-width: 640px) {
    .SharingModal {
      position: relative;
      transform: translateX(0);
      transition: transform 0.01ms linear;
      width: 100%;
      height: auto;

      .SharingModal__ctn {
        transform: translateY(0);
        opacity: 1;
        background: none;
        background-image: none !important;
        margin: 0;
        box-shadow: none;
        padding: 0 0 10px 0;

        .Mobile__title {
          text-transform: uppercase;
          color: #878787;
          text-align: center;
          width: 100%;
          font-size: 0.85em;
          font-weight: 100;
          display: inline-block;
        }

        .IframeSharing {
          height: 32px;

          input {
            color: #464646;
            background: #fff;
            width: 100%;
            border: solid 1px #dadada;
            box-sizing: border-box;
            border-right: none;
          }
        }
      }

      .SharingModal__bg {
        display: none;
      }
    }
  }
</style>
